module.exports = __webpack_public_path__ + "img/revenu-quebec.7179a0e9.svg";